/**
 * 장비 판 그림의 **여백 규칙 한 곳**(eric 2026-10-11 「원심분리기 어셈블러 염색기 보면.. 전체 균형을 맞춰줘.. 여백 같은 거 말이야.
 * 지금 염색기는 너무 화면이 붙어 있어」).
 *
 * 🔴 **값은 «기준 px»다 — 그림 좌표가 아니다.** 장비 판은 그림마다 배율이 다르다(`monitoring.css` `.eqsheet .fig-mod` 의
 *    `zoom: 기준 높이 ÷ 맞춤 높이`). 같은 좌표 간격이 어셈블러(맞춤 107)에선 염색기(맞춤 272)보다 화면에서 2.5 배 넓었다
 *    (1920 실측 — 어셈 23~30px · 염색 9px). 그래서 간격은 기준 px 하나로 두고 그림마다 제 맞춤 높이로 좌표를 환산한다(`figUnits`).
 * 🔴 맞춤 높이 숫자(`ASM_STATION_FIT_N` · `STAIN_FRONT_FIT_N`)와 기준 높이(`FIG_STD_H`)는 CSS 에도 있다(`figures.css` `--fig-fit-n` ·
 *    `--fig-std-h-n`) — 둘이 갈리면 `figureSpacing.test.ts` 가 잡는다.
 */

/** 기준 높이(트레이 상자 한 장) — CSS `--fig-std-h-n` */
export const FIG_STD_H = 242
/** 어셈블러 장치 정면도의 맞춤 높이 — CSS `.fig-mod--asm.fig-line.fig-asmstation` `--fig-fit-n` */
export const ASM_STATION_FIT_N = 107
/**
 * 염색기 정면도의 맞춤 높이 = 기준 높이 — 툴 · 평면도 · 랙 · 통이 **한 배율**로 선다(CSS `.fig-stainfront .fig-stainfront__tool` `--fig-fit-n`).
 * ⚠ 종전 272(셰이커 맞춤을 빌림)는 툴 svg 에만 걸려 툴이 평면도보다 0.89 배로 섰다 — 툴이 통 가운데보다 옆에 서고 끝이 윗변 위에서 멎었다
 *   (2026-10-11 실측 · 2026-10-12 좌우 배치로 되돌릴 때 다시 얹었다)
 */
export const STAIN_FRONT_FIT_N = FIG_STD_H

/** 부품 사이 간격(기준 px) — 상자 ↔ 상자 · 상자 ↔ 트레이 · 툴 끝 ↔ 트레이. 셋이 이 값 하나다 */
export const FIG_PART_GAP = 44
/** 이름표 틈(기준 px) — 상자 아랫변 → 이름표 글자 윗변(`dominantBaseline="hanging"`) */
export const FIG_LABEL_GAP = 17

/**
 * 이름표 한 줄의 키(기준 px) — 콘솔 그림 글자는 화면 최소 단(12px · 줄 ≈ 14px) 밑으로 안 간다(`figures.css` 장비 판 글자 하한).
 * 그림이 가장 작게 서는 판(1600 세 열 · 판 맞춤 ≈ 0.33)에서 그 14px 가 차지하는 기준 px 다 — 상자 사이에 이름표가 끼는 자리
 * (염색기 튜브 랙 ↔ 폐기통)가 이 값으로 벌어져야 이름표가 아래 상자에 안 닿는다(2026-10-11 실측: 18 단위로는 1600 에서 −1px 겹침).
 */
export const FIG_LABEL_LINE = 44

/** 기준 px → 그 그림의 좌표 단위 */
export function figUnits(stdPx: number, fitN: number): number {
  return (stdPx * fitN) / FIG_STD_H
}
